import React from 'react';
import CallReportComponent from '../../../Components/Report/CallReport';

export default function CallReport() {
    return (
        <div className='page-body'>
            <CallReportComponent />
        </div>
    );
}